import { getData } from "../../../infra3d/utils/ajax";
import { USERINPUTTYPE } from "../../userinput/internal";
import { AxisLoader } from "./internal";
export class MistraAxisLoader extends AxisLoader {
    constructor(scene, opt_options) {
        super(scene);
        this.referencedate = new Date();
        this._geoframecollectionchangeevt = -1;
        this._isloading = false;
        const options = opt_options || {};
        this._baseurl = options.baseurl || "";
        this._geoframecollectionchangeevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, (geoframecollection) => {
            const referencedate = new Date(geoframecollection.getCurrentGeoFrame().timestamp);
            this.setReferenceDate(referencedate);
        }, this);
    }
    loadaxis(extent, srid, cbs) {
        this._isloading = true;
        const addConst = 0.01;
        const variables = {
            bbox: [
                extent.minx - addConst,
                extent.miny - addConst,
                extent.maxx + addConst,
                extent.maxy + addConst,
                srid,
            ].join(),
            referenceDate: this.referencedate.toISOString(),
            outSRID: srid,
            count: true,
        };
        const url = this._baseurl + "sectors";
        const handleSucess = (respone) => {
            for (const axisfc of respone.value) {
                for (const feature of axisfc.value.features) {
                    feature.id = feature.properties.SECTOR_AXIS_SEGMENT_KEY + " " + feature.properties.SECTOR_NAME;
                    feature.properties.offset = 0.0;
                }
            }
            cbs(respone);
            this._isloading = false;
        };
        const handleError = (error) => {
            this._isloading = false;
            console.error(error.message);
        };
        getData(url, handleSucess, handleError, variables, { apiKey: this.scene.viewer.authObject.apiKey });
    }
    setReferenceDate(referencedate, networklayer) {
        if (this.referencedate !== referencedate) {
            this.referencedate = referencedate;
            if (!this._isloading && networklayer)
                networklayer.reload();
        }
    }
    destroy() {
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, this._geoframecollectionchangeevt);
    }
}
//# sourceMappingURL=mistra2.js.map